export default __webpack_public_path__ + "static/media/roadmap-q3.94aff9da.png";